<template>
  <div>
    <f7-row class="pb-05 pt-05 border-bottom-thin-solid">
      <template v-if="!!source.label">
        <f7-col class="font-bold text-color-red">{{ source.label }}</f7-col>
      </template>
      <template v-else>
        <f7-col :class="{'text-color-red': source.is_win}">{{ source.channel }}</f7-col>
        <f7-col :class="{'text-color-red': source.is_win}">{{ source.number }}</f7-col>
        <f7-col :class="{'text-color-red': source.is_win}">{{ source.command }}</f7-col>
        <f7-col :class="{'text-color-red': source.is_win}">
          {{ source.point }}{{ source.unit }}
          {{ (source.is_win > 1) ? '(x' + source.is_win + ' = ' + (source.point * source.is_win) + source.unit + ')' : '' }}
        </f7-col>
      </template>
    </f7-row>
    <f7-row class="pb-05 pt-05 border-bottom-thin-solid" v-if="source.is_win_ui > 0">
      <f7-col></f7-col>
      <f7-col></f7-col>
      <f7-col class="text-color-red">ủi</f7-col>
      <f7-col class="text-color-red">
        {{ source.point }}
        {{ (source.is_win_ui > 1) ? '(x' + source.is_win_ui + ' = ' + (source.point * source.is_win_ui) + ')' : '' }}
      </f7-col>
    </f7-row>
  </div>
</template>
<script>

export default {
  props     :{
    index :{ // index of current item
      type:Number
    },
    source:{
      type:Object,
      default(){
        return {}
      }
    }
  }
}
</script>
